import React, { FC } from "react";

type Props = {
  children?: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
};

export const CentralContent: FC<Props> = ({
  children,
  fullWidth = false,
  className = "",
}) => {
  return (
    <div
      className={`flex justify-center mx-auto min-w-[320px] w-full px-4 ${
        fullWidth ? "max-w-none" : "max-w-screen-sm"
      } ${className}`}
    >
      {children}
    </div>
  );
};
